import React from 'react';
import { Space, Spin } from 'antd';
var Api = apis.Api;
var Stream = hooks.streams.Stream;
var DanceTeamUsersSource = models.danceteams.DanceTeamUsersSource;
var DanceTeamUserItem = models.danceteams.DanceTeamUserItem;
import { apis, hooks, models } from '@vote4dance/judging-sdk';
export const DanceTeamUserNames = (props) => {
    const { item, cancelled } = props;
    const [users, loadingUsers] = Stream(DanceTeamUsersSource(item.dance_team_id));
    if (loadingUsers) {
        return React.createElement(Spin, null);
    }
    return (React.createElement(Space, { wrap: true }, users === null || users === void 0 ? void 0 : users.map((a, i) => React.createElement("span", { key: i, style: { textDecoration: cancelled ? 'line-through' : 'default' } }, DanceTeamUserItem.getFullName(a)))));
};
export const getDanceTeamUserNamesText = async (dance_team_id) => {
    const users = await Api.read(DanceTeamUsersSource(dance_team_id).url);
    return users ? users.map(a => DanceTeamUserItem.getFullName(a)).join(', ') : '';
};
